import type { FC, SVGProps } from "react";

const IconSpaTreatments: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 11H15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11 7V15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconSpaTreatments;